import EmergencyTags from './EmergencyTags';

export default EmergencyTags;
